<div #sidebar class="sidebar sidebar-right sidebar-animate">
  <div style="overflow-y: auto; overflow-x: hidden; height: 100%;">
    <div class="panel panel-primary card mb-0 box-shadow">
      <div class="tab-menu-heading border-0 p-3">
        <div class="card-title mb-0">Notifications</div>
        <div class="card-options ms-auto">
          <a
            href="javascript:void(0);"
            class="sidebar-remove"
            (click)="onClose()"
            ><i class="fe fe-x"></i
          ></a>
        </div>
      </div>
      <div class="panel-body tabs-menu-body latest-tasks p-0 border-0">
        <div class="tabs-menu">
          <ul ngbNav #nav9="ngbNav" class="panel-tabs">
            <ng-container ngbNavItem>
              <li>
                <a ngbNavLink
                  ><i class="ion ion-md-chatboxes tx-18 me-2"></i>Chat</a
                >
              </li>
              <ng-template ngbNavContent>
                <div class="tab-pane active" id="side1">
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-primary brround avatar-md"
                        >CH</span
                      >
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>New Websites is Created</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">30 mins ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-danger brround avatar-md">N</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Prepare For the Next Project</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">2 hours ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-info brround avatar-md">S</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Decide the live Discussion</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">3 hours ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-warning brround avatar-md">K</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Meeting at 3:00 pm</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">4 hours ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-success brround avatar-md">R</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Prepare for Presentation</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">1 day ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-pink brround avatar-md">MS</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Prepare for Presentation</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">1 day ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center border-bottom p-3">
                    <div class="">
                      <span class="avatar bg-purple brround avatar-md">L</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Prepare for Presentation</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto"
                            >45 minutes ago</small
                          >
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="list d-flex align-items-center p-3">
                    <div class="">
                      <span class="avatar bg-blue brround avatar-md">U</span>
                    </div>
                    <a class="wrapper w-100 ms-3" href="javascript:void(0);">
                      <p class="mb-0 d-flex">
                        <b>Prepare for Presentation</b>
                      </p>
                      <div
                        class="d-flex justify-content-between align-items-center"
                      >
                        <div class="d-flex align-items-center">
                          <i class="mdi mdi-clock text-muted me-1"></i>
                          <small class="text-muted ms-auto">2 days ago</small>
                          <p class="mb-0"></p>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem>
              <li>
                <a ngbNavLink
                  ><i class="ion ion-md-notifications tx-18 me-2"></i
                  >Notifications</a
                >
              </li>
              <ng-template ngbNavContent>
                <div class="tab-pane" id="side2">
                  <div class="list-group list-group-flush">
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/12.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Madeleine</strong> Hey! there I' am
                        available....
                        <div class="small text-muted">3 hours ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/1.jpg)"
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Anthony</strong> New product Launching...
                        <div class="small text-muted">5 hour ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/2.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Olivia</strong> New Schedule Realease......
                        <div class="small text-muted">45 mintues ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/8.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Madeleine</strong> Hey! there I' am
                        available....
                        <div class="small text-muted">3 hours ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/11.jpg)"
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Anthony</strong> New product Launching...
                        <div class="small text-muted">5 hour ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/6.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Olivia</strong> New Schedule Realease......
                        <div class="small text-muted">45 mintues ago</div>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="mr-3">
                        <span
                          class="avatar avatar-lg brround cover-image"
                          style="background: url(./assets/img/faces/9.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-3">
                        <strong>Olivia</strong> Hey! there I' am available....
                        <div class="small text-muted">12 mintues ago</div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
            <ng-container ngbNavItem>
              <li>
                <a ngbNavLink
                  ><i class="ion ion-md-contacts tx-18 me-2"></i> Friends</a
                >
              </li>
              <ng-template ngbNavContent>
                <div class="tab-pane" id="side3">
                  <div class="list-group list-group-flush">
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/9.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Mozelle Belt
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>

                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/11.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Florinda Carasco
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/11.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Alina Bernier
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/2.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Zula Mclaughin
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/13.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Isidro Heide
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/12.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Mozelle Belt
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/14.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Florinda Carasco
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/7.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Alina Bernier
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/2.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Zula Mclaughin
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/14.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Isidro Heide
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/11.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Florinda Carasco
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/9.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Alina Bernier
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/15.jpg)"
                          ><span class="avatar-status bg-success"></span
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Zula Mclaughin
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                    <div class="list-group-item d-flex align-items-center">
                      <div class="me-2">
                        <span
                          class="avatar avatar-md brround cover-image"
                          style="background: url(./assets/img/faces/4.jpg)"
                        ></span>
                      </div>
                      <div class="ms-2">
                        <div
                          class="font-weight-semibold"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                        >
                          Isidro Heide
                        </div>
                      </div>
                      <div class="ms-auto">
                        <a
                          href="javascript:;"
                          class="btn btn-sm btn-light"
                          data-toggle="modal"
                          (click)="ChatModal(chatmodel)"
                          ><i class="fab fa-facebook-messenger"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-container>
          </ul>
        </div>
        <div class="panel-body side-tab-body p-0 border-0">
          <div class="tab-content">
            <div class="tab-pane active show">
              <div [ngbNavOutlet]="nav9"></div>
            </div>
          </div>
        </div>
        <ng-template #chatmodel let-modal>
          <div
            class="modal-dialog modal-dialog-right chatbox"
            role="document"
            (click)="onClose()"
          >
            <div class="modal-content chat border-0">
              <div class="card overflow-hidden mb-0 border-0">
                <!-- action-header -->
                <div class="action-header clearfix">
                  <div class="float-start hidden-xs d-flex ms-2">
                    <div class="img_cont me-3">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img"
                        alt="img"
                      />
                    </div>
                    <div class="align-items-center mt-2">
                      <h4 class="text-white mb-0 fw-semibold">Daneil Scott</h4>
                      <span class="dot-label bg-success"></span
                      ><span class="me-3 text-white">online</span>
                    </div>
                  </div>
                  <ul class="ah-actions actions align-items-center">
                    <li class="call-icon">
                      <a
                        class="d-done d-md-block phone-button"
                        data-bs-toggle="modal"
                        (click)="
                          audioModal(audiomodal); modal.dismiss('Cross click')
                        "
                        data-bs-target="#audiomodal"
                      >
                        <i class="si si-phone"></i>
                      </a>
                    </li>
                    <li class="video-icon">
                      <a
                        class="d-done d-md-block phone-button"
                        data-bs-toggle="modal"
                        (click)="
                          videoModal(videomodal); modal.dismiss('Cross click')
                        "
                        data-bs-target="#videomodal"
                      >
                        <i class="si si-camrecorder"></i>
                      </a>
                    </li>
                    <li ngbDropdown>
                      <a
                        href="javascript:;"
                        ngbDropdownToggle
                        class="no-caret"
                        type="button"
                      >
                        <i class="si si-options-vertical no-caret"></i>
                      </a>
                      <ul
                        class="dropdown-menu dropdown-menu-right"
                        ngbDropdownMenu
                      >
                        <li ngbDropdownItem href="javascript:;">
                          <i class="fa fa-user-circle"></i> View profile
                        </li>
                        <li ngbDropdownItem href="javascript:;">
                          <i class="fa fa-users"></i>Add friends
                        </li>
                        <li ngbDropdownItem href="javascript:;">
                          <i class="fa fa-plus"></i> Add to group
                        </li>
                        <li ngbDropdownItem href="javascript:;">
                          <i class="fa fa-ban"></i> Block
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a
                        href="javascript:;"
                        class=""
                        (click)="modal.dismiss('Cross click')"
                      >
                        <span aria-hidden="true"
                          ><i class="si si-close text-white"></i
                        ></span>
                      </a>
                    </li>
                  </ul>
                </div>
                <!-- action-header end -->

                <!-- msg_card_body -->
                <div class="card-body msg_card_body">
                  <div class="chat-box-single-line">
                    <abbr class="timestamp">February 1st, 2019</abbr>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      Hi, how are you Jenna Side?
                      <span class="msg_time">8:40 AM, Today</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <div class="msg_cotainer_send">
                      Hi Connor Paige i am good tnx how about you?
                      <span class="msg_time_send">8:55 AM, Today</span>
                    </div>
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/9.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      I am good too, thank you for your chat template
                      <span class="msg_time">9:00 AM, Today</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <div class="msg_cotainer_send">
                      You welcome Connor Paige
                      <span class="msg_time_send">9:05 AM, Today</span>
                    </div>
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/9.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      Yo, Can you update Views?
                      <span class="msg_time">9:07 AM, Today</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mb-4">
                    <div class="msg_cotainer_send">
                      But I must explain to you how all this mistaken born and I
                      will give
                      <span class="msg_time_send">9:10 AM, Today</span>
                    </div>
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/9.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      Yo, Can you update Views?
                      <span class="msg_time">9:07 AM, Today</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mb-4">
                    <div class="msg_cotainer_send">
                      But I must explain to you how all this mistaken born and I
                      will give
                      <span class="msg_time_send">9:10 AM, Today</span>
                    </div>
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/9.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      Yo, Can you update Views?
                      <span class="msg_time">9:07 AM, Today</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end mb-4">
                    <div class="msg_cotainer_send">
                      But I must explain to you how all this mistaken born and I
                      will give
                      <span class="msg_time_send">9:10 AM, Today</span>
                    </div>
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/9.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                  </div>
                  <div class="d-flex justify-content-start">
                    <div class="img_cont_msg">
                      <img
                        src="./assets/img/faces/6.jpg"
                        class="rounded-circle user_img_msg"
                        alt="img"
                      />
                    </div>
                    <div class="msg_cotainer">
                      Okay Bye, text you later..
                      <span class="msg_time">9:12 AM, Today</span>
                    </div>
                  </div>
                </div>
                <!-- msg_card_body end -->
                <!-- card-footer -->
                <div class="card-footer">
                  <div class="msb-reply d-flex">
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="Typing...."
                      />
                      <div class="input-group-text bg-transparent border-0 p-0">
                        <button type="button" class="btn btn-primary">
                          <i class="far fa-paper-plane" aria-hidden="true"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- card-footer end -->
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #audiomodal let-modal>
          <div class="modal-dialog" role="document">
            <div class="modal-content border-0">
              <div class="modal-body mx-auto text-center p-7">
                <h5>Valex Voice call</h5>
                <img
                  src="./assets/img/faces/6.jpg"
                  class="rounded-circle user-img-circle h-8 w-8 mt-4 mb-3"
                  alt="img"
                />
                <h4 class="mb-1 font-weight-semibold">Daneil Scott</h4>
                <h6>Calling...</h6>
                <div class="mt-5">
                  <div class="row">
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle mb-0 mr-3"
                        href="javascript:;"
                      >
                        <i class="fas fa-volume-up bg-light"></i>
                      </a>
                    </div>
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle text-white mb-0 mr-3"
                        href="javascript:;"
                        data-dismiss="modal"
                        (click)="modal.dismiss('Cross click')"
                      >
                        <i class="fas fa-phone text-white bg-success"></i>
                      </a>
                    </div>
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle mb-0 mr-3"
                        href="javascript:;"
                      >
                        <i class="fas fa-microphone-slash bg-light"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- modal-body -->
            </div>
          </div>
        </ng-template>
        <ng-template #videomodal let-modal>
          <div class="modal-dialog" role="document">
            <div class="modal-content bg-dark border-0 text-white">
              <div class="modal-body mx-auto text-center p-7">
                <h5>Valex Video call</h5>
                <img
                  src="./assets/img/faces/6.jpg"
                  class="rounded-circle user-img-circle h-8 w-8 mt-4 mb-3"
                  alt="img"
                />
                <h4 class="mb-1 font-weight-semibold">Daneil Scott</h4>
                <h6>Calling...</h6>
                <div class="mt-5">
                  <div class="row">
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle mb-0 mr-3"
                        href="javascript:;"
                      >
                        <i class="fas fa-video-slash"></i>
                      </a>
                    </div>
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle text-white mb-0 mr-3"
                        href="javascript:;"
                        data-dismiss="modal"
                        (click)="modal.dismiss('Cross click')"
                      >
                        <i class="fas fa-phone bg-danger text-white"></i>
                      </a>
                    </div>
                    <div class="col-4">
                      <a
                        class="icon icon-shape rounded-circle mb-0 mr-3"
                        href="javascript:;"
                      >
                        <i class="fas fa-microphone-slash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- modal-body -->
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
